import { useState, useContext } from "react";
import moment from "moment";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputText from "../../../../../../../shared/components/inputs/InputText/InputText";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useLoading } from "../../../../../../../shared/context/LoadingContext";
import "./ModalEditarDadosCredencial.scss";
import toast from "react-hot-toast";
import { AuthContext } from "../../../../../../../shared/context/auth-context";

function ModalEditarDadosCredencial({
  open,
  handleCloseModal,
  idOrcamento,
  dataInicial,
  nrCredencialInicial,
  categoriaInicial,
  beneficio,
  sendRequest,
  token,
  handleUpdateCredencialData,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dataCredencial, setDataCredencial] = useState(
    dataInicial ? moment(dataInicial) : moment(),
  );
  const [nrCredencial, setNrCredencial] = useState(nrCredencialInicial || "");
  const [categoriaBeneficiario, setCategoriaBeneficiario] = useState(
    categoriaInicial || "",
  );

  const auth = useContext(AuthContext);

  const nrCredencialChangeHandler = (value) => {
    setNrCredencial(value);
  };

  const submit = async () => {
    if (!dataCredencial) {
      toast.error("A data de credencial é obrigatória");
      return;
    }

    if (!moment.isMoment(dataCredencial) || !dataCredencial?.isValid()) {
      toast.error("Preencha a data de credencial corretamente.");
      return;
    }

    if (!nrCredencial || nrCredencial.trim().length === 0) {
      toast.error("Por favor introduza o número da credencial");
      return;
    }

    // SEM validação obrigatória de categoria - é opcional!

    startLoading();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("dataCredencial", dataCredencial);
      formData.append("nrCredencial", nrCredencial);
      formData.append("utilizador", auth.userId);

      // Adicionar categoria apenas se for INPS E se tiver valor
      if (beneficio === "INPS" && categoriaBeneficiario) {
        formData.append("categoriaBeneficiario", categoriaBeneficiario);
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/dadoscredencial/${idOrcamento}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + token,
        },
      );

      toast.success("Dados da credencial atualizados com sucesso!");
      handleUpdateCredencialData(
        nrCredencial,
        dataCredencial,
        idOrcamento,
        beneficio === "INPS" ? categoriaBeneficiario : null,
      );
      handleCloseModal();
    } catch (err) {
      console.error("err", err);
      toast.error("Erro ao atualizar dados da credencial");
    } finally {
      setIsSubmitting(false);
      stopLoading();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="fluxo-atendimento__modal__box credencial__modal"
        id="modal__credencial"
      >
        <h1 className="fluxo-atendimento__modal__titulo">
          Editar Dados da Credencial
        </h1>

        <div className="modalCredencialContainer">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DesktopDatePicker
              className="valorDataCaixa__fields--field muiDatePicker"
              label="Data de Emissão*"
              inputFormat="DD-MM-YYYY"
              renderInput={(params) => <TextField {...params} />}
              onChange={(value) => setDataCredencial(value)}
              value={dataCredencial}
            />
          </LocalizationProvider>

          <InputText
            label="Nº da Credencial*"
            initialValue={nrCredencial}
            handleChange={nrCredencialChangeHandler}
          />

          {beneficio === "INPS" && (
            <FormControl fullWidth size="small" sx={{ mt: 2 }}>
              <InputLabel id="label-categoria">
                Categoria Beneficiário
              </InputLabel>
              <Select
                labelId="label-categoria"
                id="select_categoria"
                value={categoriaBeneficiario}
                label="Categoria Beneficiário*"
                onChange={(e) => setCategoriaBeneficiario(e.target.value)}
              >
                <MenuItem value="">Selecione uma categoria</MenuItem>
                <MenuItem value="TCP">Trabalhador Conta Própria</MenuItem>
                <MenuItem value="TCO">Trabalhador Conta Outrem</MenuItem>
                <MenuItem value="PA">Função Pública</MenuItem>
                <MenuItem value="MBCSS">
                  Migrantes - Beneficiários Convenções Segurança Social
                </MenuItem>
              </Select>
            </FormControl>
          )}
        </div>

        <div className="fluxo-atendimento__modal__bottom_btns">
          <span
            className="cancel-btn"
            onClick={handleCloseModal}
            style={{ display: "block" }}
          >
            Fechar
          </span>
          <span
            className="blue-button"
            disabled={isSubmitting}
            onClick={submit}
            style={{ display: "block" }}
          >
            {isSubmitting ? "Guardando..." : "Guardar"}
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalEditarDadosCredencial;
